import React from 'react';

const DEFAULT_FUNCS = ['mean', 'sum', 'min', 'max', 'count', 'stddev', 'distribution'];

// Aggregation list: rows of { field, func }. `funcs` come from the node
// catalog, so the UI only offers what the server can compute.
export default function AggsControl({ label, fields, funcs, value = [], onChange }) {
  const options = funcs && funcs.length ? funcs : DEFAULT_FUNCS;
  const update = (index, patch) =>
    onChange(value.map((agg, i) => (i === index ? { ...agg, ...patch } : agg)));
  const remove = (index) => onChange(value.filter((_, i) => i !== index));
  const add = () => onChange([...value, { field: fields?.[0]?.key || '', func: options[0] }]);

  return (
    <div className="form-field">
      <span className="form-label">{label}</span>
      {value.map((agg, index) => (
        <div className="agg-row" key={index}>
          <select
            className="agg-field"
            value={agg.field || ''}
            onChange={(e) => update(index, { field: e.target.value })}
          >
            <option value="">field…</option>
            {(fields || []).map((field) => (
              <option key={field.key} value={field.key}>
                {field.fullLabel || field.label || field.key}
              </option>
            ))}
          </select>
          <select
            className="agg-func"
            value={agg.func || options[0]}
            onChange={(e) => update(index, { func: e.target.value })}
          >
            {options.map((func) => (
              <option key={func} value={func}>
                {func}
              </option>
            ))}
          </select>
          <button
            type="button"
            className="agg-remove"
            onClick={() => remove(index)}
            title="Remove aggregation"
          >
            ×
          </button>
        </div>
      ))}
      <button type="button" className="btn btn-secondary" onClick={add}>
        + Aggregation
      </button>
    </div>
  );
}
